import { useEffect, useState  } from "react";
import { useTranslation } from "react-i18next";
import {
    TEXT_FIELD_TYPE,
    NUMERIC_FIELD_TYPE,
    DATE_FIELD_TYPE
} from "../../../helpers/constants";

export const PROPOSAL_TABLE_NAME = "discount_proposal_table";


export const useDiscountProposalFormTableFieldsConfig = () => {
    const { t } = useTranslation();

    return [
        {
            name: "product_number",
            getValueCallback: (rowData) => rowData.product_number,
            label: t("products.columns.product_number"),
            dataType: TEXT_FIELD_TYPE,
            editable: false,
        },
        {
            name: "product_type",
            getValueCallback: (rowData) => rowData.product_type,
            label: t("products.columns.product_type"),
            dataType: TEXT_FIELD_TYPE,
            editable: false,
        },
        {
            name: "product_price_net",
            getValueCallback: (rowData) => rowData.listed_price_net,
            label: t("products.columns.product_price_net"),
            dataType: NUMERIC_FIELD_TYPE,
            editable: false,
        },
        {
            name: "product_price_gross",
            getValueCallback: (rowData) => rowData.listed_price_gross,
            label: t("products.columns.product_price_gross"),
            dataType: NUMERIC_FIELD_TYPE,
            editable: false,
        },
        {
            name: "product_discount",
            getValueCallback: (rowData) => rowData.pricing_discount_max,
            label: t("products.columns.product_discount"),
            dataType: NUMERIC_FIELD_TYPE,
            editable: false,
        },
        {
            name: "proposal_discount",
            getValueCallback: (rowData) => rowData.proposal_discount,
            label: t("products.columns.proposal_discount"),
            dataType: NUMERIC_FIELD_TYPE,
            editable: true,
        },
        {
            name: "proposal_discount_pln",
            getValueCallback: (rowData) => (
                rowData.proposal_discount_pln ? rowData.proposal_discount_pln :
                rowData.proposal_discount && rowData.listed_price_gross 
                ? (parseFloat(rowData.proposal_discount).toFixed(10) * parseFloat(rowData.listed_price_gross).toFixed(10) / 100).toFixed(2)
                : null
            ),
            // getValueCallback: (rowData) => rowData.proposal_discount_pln,
            label: t("products.columns.proposal_discount_pln"),
            dataType: NUMERIC_FIELD_TYPE,
            editable: true,
        },
        {
            name: "proposal_discount_pln_m2",
            getValueCallback: (rowData) => (
                rowData.proposal_discount && rowData.listed_price_per_sqm_gross 
                ? (parseFloat(rowData.proposal_discount).toFixed(10) * parseFloat(rowData.listed_price_per_sqm_gross).toFixed(10) / 100).toFixed(2)
                : null
            ),
            // getValueCallback: (rowData) => rowData.proposal_discount_pln_m2,
            label: t("products.columns.proposal_discount_pln_m2"),
            dataType: NUMERIC_FIELD_TYPE,
            editable: false,
        },
        {
            name: "product_price_net_after_discount",
            getValueCallback: (rowData) => (
                rowData.proposal_discount && rowData.listed_price_net 
                ? (rowData.listed_price_net - parseFloat(rowData.proposal_discount).toFixed(10) * parseFloat(rowData.listed_price_net).toFixed(10) / 100).toFixed(2)
                : null
            ),
            // getValueCallback: (rowData) => rowData.product_price_net_after_discount,
            label: t("products.columns.product_price_net_after_discount"),
            dataType: NUMERIC_FIELD_TYPE,
            editable: false,
        },
        {
            name: "product_price_gross_after_discount",
            getValueCallback: (rowData) => (
                rowData.proposal_discount && rowData.listed_price_gross 
                ? (rowData.listed_price_gross - parseFloat(rowData.proposal_discount).toFixed(10) * parseFloat(rowData.listed_price_gross).toFixed(10) / 100).toFixed(2)
                : null
            ),
            // getValueCallback: (rowData) => rowData.product_price_gross_after_discount,
            label: t("products.columns.product_price_gross_after_discount"),
            dataType: NUMERIC_FIELD_TYPE,
            editable: false,
        }
    ];
};
